import { CreateMUIStyled, createStyled } from '@mui/system';

import { defaultThemeValues } from './defaultThemeValues';
import { KitTheme } from './theme.types';

export const styled: CreateMUIStyled<KitTheme> = createStyled({
  themeId: 'default',
  defaultTheme: defaultThemeValues as KitTheme,
});
